<!-- 
 * @description:积分商场列表入口页面
 * @fileName: index.vue 
 * @date: 2023-08-29 17:30:03
!-->
<template>
    <div class="integral-mall">
        <div class="integral-mall-container">
            <div class="goods-category">
                <div class="category-first category-level">
                    <span class="category-first-name">商品分类：</span>
                    <div class="category-item">

                        <span
                            v-for="item in classifyList"
                            :key="item.code"
                            :class="{active:item.code==firstCode}"
                            @click="selectCategory(item)"
                        >{{item.name}}</span>
                    </div>
                </div>
                <div class="category-second category-level"
                    v-if="classifySecondList && classifySecondList.length>1">
                    <div class="category-item">
                        <span
                            v-for="item in classifySecondList"
                            :key="item.code"
                            :class="{active:item.code==secondCode}"
                            @click="selectSecondCategory(item)"
                        >{{item.name}}</span>
                    </div>
                </div>
            </div>
            <div class="usable-points">
                <p><span>可用积分：</span><span class="points">{{integral}}</span></p>
            </div>
            <ul class="goods-list" v-if="list && list.length>0">
                <li v-for="item in list" :key="item.id" @click="jumpDetail(item)">
                    <img :src="item.picUrl" alt="">
                    <p class="title">{{item.name}}</p>
                    <p class="points">{{item.salePrice || 0 }}积分</p>
                </li>
            </ul>
            <paging class="paging pagingCustom" :paging="paging" v-if="paging.total>20" />
            <div v-if="list && list.length==0" class="empty-goods">
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-pc/junmin/emptyData.png">
                <p>暂无可兑换商品，持续更新中，敬请期待~</p>
            </div>
        </div>
    </div>
</template>
<script>
import paging from "../../../layout/paging";
export default {
    name:'IntegralMall',
    data(){
        return{
            classifyList:[],//一级分类
            classifySecondList:[],//二级分类
            integral:0,//积分
            list:null,
            paging: {
                params: {
                    pageNum: 1,
                    pageSize: 20
                },
                total: 0,
                totalPages: 0,
                currentSize: 0,
            },
            firstCode:'all',
            secondCode:'all',
            categoryCode:'',
        }
    },
    components: {
        paging,
    },
    created(){
        this.goodsCategoryTree();
        this.getData();
        this.getUsablePoints();
    },
    methods:{
        jumpDetail(item){
            this.$router.push({
                path:'/points-for-goods/detail',
                query:{
                    id:item.id
                }
            })
        },
        // 一级分类
        selectCategory(item){
            this.paging.params.pageNum = 1;
            this.classifySecondList = [];
            this.firstCode = item.code;
            this.categoryCode = item.code=='all'?'':item.code;
            if(item.children){
                let arr = JSON.parse(JSON.stringify(item.children)) || []
                arr.unshift({ name: '全部', code: item.code, status: 1})
                this.classifySecondList = arr.filter(item => item.status == 1)
                this.secondCode = item.code;
            }
            this.getData();
        },
        // 二级分类
        selectSecondCategory(item){
            this.paging.params.pageNum = 1;
            this.secondCode = item.code;
            this.categoryCode = item.code;
            this.getData();
        },
        // 积分商品列表
        getData(){
            const params = this.paging.params;
            const data = {
                status:1,
               categoryCode:this.categoryCode
            }
            this.$api.integralMall.getGoodsList({params,data}).then(res=>{
                if(res.code==0){
                    this.list = res.data.list;
                    this.paging.total=res.data.total;
                }
            })
        },
        // 积分商品分类
        async goodsCategoryTree() {
            const res = await this.$api.integralMall.goodsCategoryTree({ businessType: 5, name: '' })
            // status 0禁用 1启用
            if(res.code!=0) return
            this.classifyList = this.filterTreeData(res.data)
            this.classifyList.unshift({name:'全部',code:'all'})
        },
        // 过滤可使用分类
        filterTreeData (data) {
            let newArr = data.filter(item=>{
                return item.status==1
            })
            return newArr.map( item => {
                if (item.children) {
                item.children = this.filterTreeData(item.children)
                }
                return item
            })
        },
        // 可用积分
        getUsablePoints(){
            const branchId = localStorage.getItem('solutionInfo')?JSON.parse(localStorage.getItem('solutionInfo')).defaultBranchId:''
            this.$api.integralMall.getUsablePoints(
                {saasId:localStorage.getItem('saasId'),
                branchId:branchId}
            ).then(res=>{
                if(res.code==0){
                    this.integral = res.data;
                }
            })
        }
    }
}
</script>
<style lang="stylus" scoped>
.integral-mall{
    background:#F8FAFF;
    overflow:hidden;
    min-height: calc(100vh - 200px)
    .integral-mall-container{
        width:1200px;
        margin:28px auto 0;
        padding-bottom:30px;
    }
}
.goods-category{
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #E7EAF3;
    box-sizing:border-box;
    span{
        color:#5B5F6E;
        line-height:32px;
        font-weight:500;
    }
    .category-level{
        padding:12px 16px;
    }
    .category-item{
        margin-left:74px;
        span{
            padding:0 14px;
            margin-left:12px;
            display:inline-block;
            &.active{
                color:#1972FF;
            }
            &:hover{
                cursor:pointer;
                color:#1972FF;
            }
        }
    }
}
.category-first{
    .category-item{
        margin-left:4px;
        span{
            font-size:16px;
        }
        span.active{
            background:#1972FF;
            color:#fff;
            border-radius:4px;
        }
    }
    display:flex;
    .category-first-name{
        color:#333;
        word-break: keep-all;
    }
}
.category-second{
    border-top:1px solid #E7EAF3;
}
.usable-points{
    background:#fff;
    font-size:16px;
    padding:0px 16px;
    height:56px;
    line-height:56px;
    border: 1px solid #E7EAF3;
    box-sizing:border-box;
    border-radius:8px;
    margin:24px 0;
    .points{
        color:#1972FF;
    }
}
ul.goods-list{
    display:flex;
    flex-wrap:wrap;
    li{
        width: 282px;
        height: 324px;
        background: #FFFFFF;
        border: 1px solid #E7EAF3;
        box-sizing:border-box;
        margin-bottom: 24px;
        margin-right 24px;
        &:hover{
            cursor:pointer;
            .title{
                color:#1972FF;
            }
        }
        &:nth-child(4n){
            margin-right:0;
        }
        img{
            height:210px;
            width: 100%;
            object-fit:cover;
            vertical-align: middle;
        }
        p{
            margin: 0 12px;
        }
        .title{
            font-size: 16px;
            line-height: 26px;
            height:52px;
            color: #5B5F6E;
            margin-top 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: box;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .points{
            font-size: 20px;
            line-height: 20px;
            font-weight: 500;
            color: #EB5042;
            margin-top: 16px;
        }
    }
}
.empty-goods{
    text-align center;
    img{
        width:470px;
        margin-top:145px;
        margin-bottom:8px;
        vertical-align:middle;
    }
    p{
        font-size:26px;
        line-height:37px;
        color:#999;
    }
}
</style>

